import { css } from "@emotion/core";

const base = css`
  background: #373742;
  border-radius: 10px;
  border: none;
  color: #fff;

  &[disabled] {
    background: #999;
  }
`;

export const medium = css`
  ${base}
  padding: 20px 30px;
  min-width: 140px;
`;

export const large = css`
  ${base}
  padding: 25px 40px;
  display: block;
  width: 100%;
  max-width: 360px;
  margin: 0 auto;
`;

export const white = css`
  color: #373742;
  background: #fff;
`;
